/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Empty_TitleInputs */

const en_search_empty_title = /** @type {(inputs: Search_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No listings found`)
};

const es_search_empty_title = /** @type {(inputs: Search_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron anuncios`)
};

const fr_search_empty_title = /** @type {(inputs: Search_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune annonce trouvée`)
};

const de_search_empty_title = /** @type {(inputs: Search_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Inserate gefunden`)
};

const ja_search_empty_title = /** @type {(inputs: Search_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品が見つかりません`)
};

const zh_search_empty_title = /** @type {(inputs: Search_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到商品`)
};

const ar_search_empty_title = /** @type {(inputs: Search_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على إعلانات`)
};

const id_search_empty_title = /** @type {(inputs: Search_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada listing yang ditemukan`)
};

const it_search_empty_title = /** @type {(inputs: Search_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun annuncio trovato`)
};

const ru_search_empty_title = /** @type {(inputs: Search_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объявления не найдены`)
};

const pt_search_empty_title = /** @type {(inputs: Search_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum anúncio encontrado`)
};

const ko_search_empty_title = /** @type {(inputs: Search_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품을 찾을 수 없습니다`)
};

/**
* | output |
* | --- |
* | "No listings found" |
*
* @param {Search_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const search_empty_title = /** @type {((inputs?: Search_Empty_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Empty_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_empty_title(inputs)
	if (locale === "es") return es_search_empty_title(inputs)
	if (locale === "fr") return fr_search_empty_title(inputs)
	if (locale === "de") return de_search_empty_title(inputs)
	if (locale === "ja") return ja_search_empty_title(inputs)
	if (locale === "zh") return zh_search_empty_title(inputs)
	if (locale === "ar") return ar_search_empty_title(inputs)
	if (locale === "id") return id_search_empty_title(inputs)
	if (locale === "it") return it_search_empty_title(inputs)
	if (locale === "ru") return ru_search_empty_title(inputs)
	if (locale === "pt") return pt_search_empty_title(inputs)
	return ko_search_empty_title(inputs)
});